import React, { useEffect, useState } from "react";
import { Skeleton, Tabs, Alert, Button } from "antd";
import { Link } from "react-router-dom";
import CardIssuing from "./card";
import { useParams } from "react-router-dom";
import { gql, useLazyQuery } from "@apollo/client";

function Setting(props) {
  const [confirmStatus, setConfigStatus] = useState(null);
  const CONFIRMSTATUS = gql`
    query {
      getProfile {
        confirmStatus
      }
    }
  `;

  const [getConfirmStatusData, confirmStatusData] = useLazyQuery(
    CONFIRMSTATUS,
    {
      onCompleted(data) {
        setConfigStatus(data?.getProfile?.confirmStatus);
      },
      onError(err) {
        console.warn(err)
      }
    }
  );
  useEffect(() => {
    getConfirmStatusData();
  }, []);
  const { target } = useParams();


  if (confirmStatusData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  if (!confirmStatus)
    return (
      <Alert
        message="لطفا پروفایل خود را تکمیل کنید."
        type="warning"
        banner
        style={{ width: "100%", marginBottom: "30px" }}
        action={
          <Button size="small" danger>
            <Link to="/profile"> تکمیل پروفایل</Link>
          </Button>
        }
      />
    );
  if (confirmStatus === "PENDING")
    return (
      <Alert
        message="پروفایل شما در حال بررسی است. بعد از بررسی و تایید مدیریت میتوانید درخواست صدور کارت بدهید."
        type="info"
        banner
        style={{ width: "100%", marginBottom: "30px" }}
      />
    )
  return <CardIssuing />;
}

export default Setting;
